import {
    FETCH_ACCOUNTS,
    FETCH_ACCOUNTS_SUCCESS,
    FETCH_ACCOUNTS_ERROR,
    LOAD_ACCOUNTS_DETAIL,
    ACCOUNTS_DETAIL_ERROR,
    ACCOUNTS_UNMOUNT_DETAIL,
    ACCOUNTS_DETAIL_DATA,
    FETCH_ACCOUNT_SETTINGS,
    FETCH_ACCOUNT_SETTINGS_SUCCESS,
    FETCH_ACCOUNT_SETTINGS_ERROR,
    UPDATE_ACCOUNT_GENERAL_SETTINGS,
    REGISTER_USER_SUCCESS,
    // Fetch Account Invoices
    FETCH_ACCOUNT_INVOICES,
    FETCH_ACCOUNT_INVOICES_SUCCESS,
    FETCH_ACCOUNT_INVOICES_ERROR,
} from './constants';

const initialState = {
    list: {
        data: [],
        hasError: false,
        isLoading: false,
    },
    detail: {
        data: {},
        isLoading: false,
        hasError: false,
    },
    settings: {
        data: {},
        isLoading: false,
        hasError: false,
    },
    invoices: {
        data: [],
        isLoading: false,
        hasError: false,
    },
};

const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case FETCH_ACCOUNTS:
            return {
                ...state,
                list: {
                    ...state.list,
                    hasError: false,
                    isLoading: true,
                },
            };

        case REGISTER_USER_SUCCESS: {
            return {
                ...state,
                list: {
                    data: [payload, ...state.list.data],
                    hasError: false,
                    isLoading: false,
                },
            };
        }
        case FETCH_ACCOUNTS_SUCCESS:
            return {
                ...state,
                list: {
                    data: payload,
                    hasError: false,
                    isLoading: false,
                },
            };
        case FETCH_ACCOUNTS_ERROR:
            return {
                ...state,
                list: {
                    ...state.list,
                    hasError: true,
                    isLoading: false,
                },
            };
        case LOAD_ACCOUNTS_DETAIL:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    hasError: false,
                    isLoading: true,
                },
            };
        case ACCOUNTS_DETAIL_DATA:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    data: payload.data,
                    hasError: false,
                    isLoading: false,
                },
            };
        case ACCOUNTS_DETAIL_ERROR:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    hasError: true,
                    isLoading: false,
                    data: null,
                },
            };
        case ACCOUNTS_UNMOUNT_DETAIL:
            return {
                ...state,
                detail: initialState.detail,
            };
        case FETCH_ACCOUNT_SETTINGS:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    hasError: false,
                    isLoading: true,
                },
            };
        case FETCH_ACCOUNT_SETTINGS_SUCCESS:
            return {
                ...state,
                settings: {
                    data: payload,
                    hasError: false,
                    isLoading: false,
                },
            };
        case FETCH_ACCOUNT_SETTINGS_ERROR:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    hasError: true,
                    isLoading: false,
                },
            };
        case UPDATE_ACCOUNT_GENERAL_SETTINGS: {
            return {
                ...state,
                settings: {
                    ...state.settings,
                    hasError: false,
                    isLoading: true,
                },
            };
        }
        case FETCH_ACCOUNT_INVOICES:
            return {
                ...state,
                invoices: {
                    ...state.invoices,
                    isLoading: true,
                    hasError: false,
                },
            };
        case FETCH_ACCOUNT_INVOICES_SUCCESS:
            return {
                ...state,
                invoices: {
                    ...state.invoices,
                    data: payload.data,
                    isLoading: false,
                    hasError: false,
                },
            };
        case FETCH_ACCOUNT_INVOICES_ERROR:
            return {
                ...state,
                invoices: {
                    ...state.invoices,
                    isLoading: false,
                    hasError: true,
                },
            };

        default:
            return state;
    }
};

export default reducer;
